export const isCustomProduct = (dataUser, configId) => {
    return dataUser.ACCOUNTNUM === configId;
}; 